import { Box, Typography, useTheme } from "@mui/material";
import botbridgeimgUrl from "../assets/images/botbridge_logo.png";
import carepmsimgUrl from "../assets/images/Care_New_Logo.png";
import { useBranding } from "../hooks/brandingProvider";

export default function Logo() {
  const theme = useTheme();
  const tenant = localStorage.getItem("tenant");
  const { logo_url: domainLogoUrl } = useBranding() || {};

  // Determine which logo to display based on tenant value
const logoUrl = tenant === "carepms" ? carepmsimgUrl : domainLogoUrl || "";
  const companyName = tenant === "carepms" ? "" : ""; //TODO: integrate backend and make dynamic

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "15px",
      }}
    >
      {logoUrl && (
  <Box
    component="img"
    src={logoUrl}
    sx={{
      objectFit: "contain",
      height: {
        xs: "24px",
        sm: "36px",
        md: "45px",
      },
      width: "auto",
      maxWidth: {
        xs: "150px",
        md: "200px",
      },
      display: "block",
    }}
    alt="Company Logo"
  />
)}
      {companyName && (
        <Box>
          <Typography variant="h4">{companyName}</Typography>
        </Box>
      )}
    </Box>
  );
}
